(function($) {
  'use strict';

  const RevotyShippingBar = {
    init: function() {
      this.updateBar();
      this.bindEvents();
    },

    bindEvents: function() {
      // Update bar when cart changes (WooCommerce events)
      $(document.body).on('updated_cart_totals updated_checkout', () => {
        this.updateBar();
      });

      // Update bar on AJAX add to cart
      $(document.body).on('added_to_cart', () => {
        this.updateBar();
      });
    },

    updateBar: function() {
      $.ajax({
        url: revotyShippingBar.ajaxUrl,
        type: 'POST',
        data: {
          action: 'revoty_update_shipping_bar',
          nonce: revotyShippingBar.nonce
        },
        success: function(response) {
          if (response.success) {
            const bar = $('.revoty-shipping-bar');
            const message = bar.find('.revoty-shipping-bar__message');
            const progressBar = bar.find('.revoty-shipping-bar__progress-bar');

            // Update message
            message.html(response.data.message);

            // Update progress bar
            progressBar.css('width', response.data.percentage + '%');

            // Toggle qualified class
            if (response.data.qualified) {
              bar.addClass('revoty-shipping-bar--qualified');
            } else {
              bar.removeClass('revoty-shipping-bar--qualified');
            }
          }
        }
      });
    }
  };

  // Initialize on document ready
  $(document).ready(function() {
    if (typeof revotyShippingBar !== 'undefined') {
      RevotyShippingBar.init();
    }
  });

})(jQuery);
